import React from 'react';
import { BsHeart, BsHeartFill } from 'react-icons/bs';
import { MdStar } from 'react-icons/md';
import { Box, Button, Center, chakra, Divider, HStack, Icon, Image, Text } from '@chakra-ui/react';
import { ProductCardProps } from './ProductCard.types';

export const ProductCardShowcase: React.FC<ProductCardProps> = (props) => {
  const {
    displayName,
    percentageOff = 0,
    listPrice = 0,
    salePrice,
    installmentPrice = 0,
    numberOfInstallments = 0,
    numberOfReviews = 0,
    rating = 0,
    desired = false,
    imageURL,
    onToggleFromWishlist,
  } = props;

  return (
    <Box position="relative" overflow="hidden" rounded="base" boxShadow="2xl" bg="white" w={48}>
      {percentageOff > 0 && (
        <Box
          position="absolute"
          rounded="base"
          bg="yellow.400"
          color="white"
          fontSize="sm"
          fontWeight="semibold"
          px={2}
          py={0.5}
          top={2.5}
          left={2.5}
        >
          {`- ${percentageOff}%`}
        </Box>
      )}

      <Button
        position="absolute"
        boxShadow="md"
        size="xs"
        rounded="full"
        bg="white"
        variant="ghost"
        w={7}
        h={7}
        pt={0.5}
        top={2}
        right={2}
        onClick={onToggleFromWishlist}
      >
        <Icon
          as={desired ? BsHeartFill : BsHeart}
          color={desired ? 'blue.400' : 'gray.300'}
          w={4}
          h={4}
        />
      </Button>

      <Center bg="white" py={2}>
        <Image src={imageURL} h={32} />
      </Center>

      <Box p={3}>
        <Text fontSize="sm" fontWeight="medium" noOfLines={2}>
          {displayName}
        </Text>

        <HStack mt={1.5} spacing={0.5}>
          {Array(5)
            .fill(null)
            .map((_, index) => {
              const color = rating > index ? 'yellow.400' : 'gray.300';

              return <Icon key={`star_${index}`} as={MdStar} color={color} w={3} h={3} />;
            })}

          <Text fontSize="sm" lineHeight="none" color="gray.600" pl={1}>
            ({numberOfReviews})
          </Text>
        </HStack>

        <HStack mt={2} spacing={2}>
          {listPrice > salePrice && (
            <Text as="s" fontSize="sm" fontWeight="medium" color="gray.400">
              {listPrice}
            </Text>
          )}

          <Text fontSize="md" fontWeight="bold" color="blue.400">
            {salePrice}
          </Text>
        </HStack>

        <Divider my={1} />

        <Text fontSize="xs" fontWeight="medium" color="gray.500">
          {`${numberOfInstallments}x `}
          <chakra.span fontWeight="extrabold">{installmentPrice}</chakra.span>
          {` sem juros`}
        </Text>
      </Box>
    </Box>
  );
};
